import { StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { usePageContext } from '@lib/pimster-stories/contexts/PageContext';

import ProgressAnimation from './ProgressAnimation';
import { useProgressContext } from '../../contexts/ProgressContext';

type PropsType = { index: number };

type WrapperProps = { isPaused: boolean; isFilled: boolean };

const ProgressWrapper = styled.div<StyledProps<WrapperProps>>`
    height: 2px;
    margin: 2px;
    flex-grow: 1;
    background: ${({ theme, isFilled }) =>
        isFilled ? theme.palette.common.white : theme.palette.grey[400]};
    opacity: ${({ isPaused }) => (isPaused ? 0 : 1)};
    transition: opacity 400ms ease-in-out;
    position: relative;
`;

const ProgressLine = ({ index }: PropsType) => {
    const { isPaused, currentPageIndex } = useProgressContext();
    const { pageIndex } = usePageContext();
    const animate = pageIndex === index && currentPageIndex === index;

    return (
        <ProgressWrapper
            isPaused={isPaused}
            isFilled={currentPageIndex > index}
        >
            {animate && <ProgressAnimation />}
        </ProgressWrapper>
    );
};

export default ProgressLine;
